import React from 'react';
import styled from 'styled-components';

export const eventThumbnailContent = item => <Img src={item.src} alt="" />;

const Img = styled.img`
  width: 75px;
  height: 75px;

  @media screen and (max-width: 767px) {
    width: 56px;
    height: 56px;
  }
`;
